import { LABELS_DISPLAY } from '../constants.js';
import type { LabelsDisplay } from '../types/treemap.js';

export const withParentLabel = (labelsDisplay: LabelsDisplay) => {
  const parentLabels: string[] = [LABELS_DISPLAY.All, LABELS_DISPLAY.Clusters];
  return parentLabels.includes(labelsDisplay);
};
